import { PolicyPageWrapper } from './PolicyPageWrapper'
import SeoHelmet from '../../components/common/SeoHelmet'

const PrivacyPolicyPage = () => (
  <>
    <SeoHelmet
      title="Privacy Policy"
      description="Read Sokooni's privacy policy to understand how we collect, use, and protect your personal information on our marketplace platform."
      keywords="privacy policy, data protection, personal information, user privacy, Sokooni privacy"
      url="/privacy-policy"
    />
    <PolicyPageWrapper title="Privacy Policy">
      <p>
        Welcome to Sokooni! Your privacy is important to us. This Privacy Policy explains how we
        collect, use, and protect your personal information when you use our website and services.
      </p>

      <h2 className="text-2xl font-semibold mt-4">1. Who We Are</h2>
      <p>
        Sokooni is an online marketplace that connects buyers and sellers across Kenya. We are
        committed to safeguarding your personal data and ensuring transparency in how we handle it.
      </p>

      <h2 className="text-2xl font-semibold mt-4">2. Information We Collect</h2>
      <ul className="list-disc list-inside mb-6">
        <li>
          <strong>Personal Information:</strong> When you register or use our services, we may
          collect your name, email address, phone number, and location.
        </li>
        <li>
          <strong>Usage Data:</strong> Information about how you interact with our platform, such as
          pages visited, time spent, and items viewed.
        </li>
        <li>
          <strong>Device Information:</strong> Details about the device you use to access Sokooni,
          including IP address, browser type, and operating system.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">3. How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-6">
        <li>Provide and maintain our services.</li>
        <li>Facilitate transactions between buyers and sellers.</li>
        <li>Communicate with you about your account or transactions.</li>
        <li>Improve our platform and develop new features.</li>
        <li>Comply with legal obligations.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">4. Sharing Your Information</h2>
      <ul className="list-disc list-inside mb-6">
        <li>
          <strong>Service Providers:</strong> Third parties who assist us in operating our platform,
          such as payment processors and delivery services.
        </li>
        <li>
          <strong>Legal Authorities:</strong> When required by law or to protect our rights and
          users.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4">5. Your Rights</h2>
      <p>You have the right to:</p>
      <ul className="list-disc list-inside mb-6">
        <li>Access the personal data we hold about you.</li>
        <li>Request correction of inaccurate information.</li>
        <li>Request deletion of your data, subject to legal obligations.</li>
        <li>Object to or restrict certain processing of your data.</li>
      </ul>
      <p>
        To exercise these rights, please contact us at{' '}
        <a href="mailto:support@sokooni.com" className="text-blue-600 hover:underline">
          support@sokooni.com
        </a>
        .
      </p>

      <h2 className="text-2xl font-semibold mt-4">6. Data Security</h2>
      <p>
        We implement appropriate security measures to protect your data from unauthorized access,
        alteration, disclosure, or destruction.
      </p>

      <h2 className="text-2xl font-semibold mt-4">7. Retention of Data</h2>
      <p>
        We retain your personal information only as long as necessary to provide our services and
        fulfill legal obligations.
      </p>

      <h2 className="text-2xl font-semibold mt-4">8. Cookies and Tracking Technologies</h2>
      <p>
        We use cookies to enhance your experience on Sokooni. You can manage your cookie preferences
        through your browser settings.
      </p>

      <h2 className="text-2xl font-semibold mt-4">9. Children's Privacy</h2>
      <p>
        Sokooni is not intended for individuals under the age of 18. We do not knowingly collect
        data from children.
      </p>

      <h2 className="text-2xl font-semibold mt-4">10. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of significant
        changes by posting the new policy on our website.
      </p>

      <h2 className="text-2xl font-semibold mt-4">11. Contact Us</h2>
      <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
      <p>
        <strong>Email:</strong>{' '}
        <a href="mailto:support@sokooni.com" className="text-blue-600 hover:underline">
          support@sokooni.com
        </a>
        <br />
        <strong>Address:</strong> Sokooni E-Commerce Limited., P.O. Box 12345, Nairobi, Kenya
      </p>
    </PolicyPageWrapper>
  </>
)

export default PrivacyPolicyPage
